/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum ProtectedVmSimilarJobTypes {
    Single,
    Multiple,
}
